import { isObject, map, isEmpty } from 'lodash';
import queryString from 'query-string'
import fetch from 'isomorphic-fetch'

export function getHeaders(state, customHeaders) {
    let headers = {
        "Content-type": "application/json;charset=UTF-8"
    }
    if (localStorage.getItem('apitoken')) {
        headers['X-NPOCONNECT-AUTHENTICATION-TOKEN'] = 'Token ' + localStorage.getItem('apitoken')
    }

    return Object.assign({}, headers, customHeaders)
}

function addQueryParams(url, params) {
    const parsedUrl = queryString.parseUrl(url)
    parsedUrl.query = Object.assign({}, params, parsedUrl.query)
    return parsedUrl.url + '?' + queryString.stringify(parsedUrl.query)
}

export function absUrl(url) {
    const apiBaseUrl = window.LOCAL_SETTINGS.API_BASE
    return apiBaseUrl + url
}

export function put(state, url, data) {
    // TODO state not being used - remove from function
    return post(state, url, data, 'PUT')
}

export function post(state, url, data, method='POST') {
    // TODO state not being used - remove from function
    try {
        if (isObject(data)) {
            data = JSON.stringify(data)
        }

        const headers = getHeaders()
        url = addQueryParams(absUrl(url + '/'))

        let res = fetch(url, {
            method: method,
            headers: headers,
            body: data
        })
        
        return res.then(handleResponse)
    } catch (error) {
        throw error
    }
}

export function get(url, params, custom_headers) {
    let headers = getHeaders(custom_headers)

    if (params) {
        url = absUrl(url + serialize(params))
    } else {
        url = absUrl(url)
    }

    let res = fetch(url, {
        method: "GET",
        headers: headers
    })

    return res.then(handleResponse)
}

export function del(state, url, params) {
    // TODO state not being used - remove from function
    return post(state, url, params, 'DELETE')
}

function handleResponse(response) {
    let contentType = response.headers.get("content-type");
    const xPagination = response.headers.get("x-pagination");
    const pagination = parsePagination(xPagination)
    const isJson = contentType && contentType.indexOf("application/json") !== -1
    const isSuccessful = response.status < 400
    if (isJson) {
        if (isEmpty(pagination)) {
            return Promise.all([response.json(), response, isSuccessful, {}])
        } else {
            let payload = response.json()
            return Promise.all([payload, response, isSuccessful, pagination])
        }
    } else {
        return Promise.all([response.text(), response, isSuccessful, {}]);
    }
}

function parsePagination(pagination_string) {
    let context = {}
    if (pagination_string !== null && pagination_string.indexOf(';') !== -1) {
        let items = pagination_string.split(';')
        map(items, function(item) {
            let value = item.split('=')
            context[value[0]] = parseInt(value[1], 10)
        })
    }
    return context
}

function serialize(obj) {
    return '?' + Object.keys(obj).reduce(
        function(a, k){
            if (obj[k] !== null && obj[k] !== undefined) {
                a.push(k + '=' + encodeURIComponent(obj[k]));
            }
            return a
        }, []).join('&')
}
